import { useState, useEffect, useRef, useMemo } from "react";
import "./crash.scss";
import { Dropdown, Modal, Offcanvas, OverlayTrigger } from "react-bootstrap";
import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { useRecoilState, useRecoilValue } from "recoil";
import { userProfileData, userSmartAccount, userSmartAccountUsdtBalance } from "../RecoilAtom";
import Loader from "../../hooks/loader";
import { arbiscan_url, CRASH_GAME_CONTRACT, LIQUIDITY_CONTRACT, WHITE_LISTED_CRASHGAME_ADDRESSES, minBetGlobal, ALCHEMY_RPC_URL, RNG_CONTRACT } from "../../utils/Enviroment";
import useWeb3 from "../../hooks/useWeb3";
import { ethers } from "ethers";
import CrashGameABI from "../../utils/CrashGameAbi.json";
import { callCrashGameGraphQLQuery } from "../../hooks/crashHooksdummy/axiosClient";
import Web3 from "web3";
import TotalLiquidity from "../../hooks/crashHooksdummy/dataFetcher/TotalLiquidity";
import { useCheckAllowance } from "../../hooks/crashHooksdummy/dataSender/allowance";
import { useSessionPermissions } from "../../hooks/checkSessionPermissions";
import Players from "./Players";
import { getGameLiquidityContract, } from "../../utils/contractHelpers";
import useCrashDataFetcher from "../../hooks/dataFetcher/useCrashDataFetcher";
import { Link, useNavigate } from "react-router-dom";
import { autoCashoutVerificationSignature, cashoutVerificationSignature, getIsGameInProgress, getPlaceBetData, postMarketDisclaimer, } from "../../utils/services";
import { useGetAllBalances } from "../AllBalances";
import { useContractEvents, useSocketEvents } from "../../hooks/dataFetcher/Socket";
import { notifyError, notifyWarning } from "../Toast";
import { calculationForPayOut, convertBetAmountWithOutFee, convertFromWei, convertXvalueToPercentage, convertXvalueToPercentageOnlyForPayoutX, epochToDateFormate, formatNumbers, formatNumberWithCommas, formatSmartDecimal, getFormatedWeb3Address, handleCheckSession, shortenAddress, shortenName } from "../../utils/helpers";
import { LIGHT_THEME, WHITELISTING_CHECK_TIME } from "../../utils/constants";
import Footer from "../landing/footer/Footer";
import ShareCrash from "./ShareCrash";
import { useTheme } from "../../contexts/ThemeProvider";
import TooltipCustom from "react-bootstrap/Tooltip";
import { useEoaAccount } from "../../hooks/useEoaAccount";
import { useTranslation } from "react-i18next";
import LiquidityLoader from "../../hooks/liquidityLoader";
import ReconnectingLoader from "../../hooks/dataFetcher/rocinnectingLoader";
import { Helmet } from "react-helmet";
gsap.registerPlugin(MotionPathPlugin);

const Crash = () => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);
  const { theme } = useTheme();
  const [show11, setShow11] = useState(false);
  const handleClose11 = () => setShow11(false);
  const handleShow11 = () => setShow11(true);
  const { TotalLiquidityHook } = TotalLiquidity();
  const [maxBet, setMaxBet] = useState(null);
  const [userCashoutValue, setUsercashOutValue] = useState(0)
  const [isBetLoss, setIsBetLoss] = useState(false)
  const [totalLiquidity, setTotalLiquidity] = useState(null);
  const [cashoutotherCheck, setCashoutOtherCheck] = useState(false);
  const web3 = useWeb3();
  const [isMobile, setIsMobile] = useState(false);
  let cashoutSaved = localStorage.getItem("AutoCashOut");
  const rocketRef = useRef(null);
  const pathRef = useRef(null);
  const tlRef = useRef(null);
  const intervalRef = useRef(null);
  const { checkAllowance } = useCheckAllowance();
  const [autoCashout, setAutoCashOut] = useState(null);
  const [pendingBetAmount, setPendingBetAmount] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(null);
  const smartAccount = useRecoilValue(userSmartAccount);
  const smartAccountUsdtBalance = useRecoilValue(userSmartAccountUsdtBalance);
  const navigate = useNavigate();
  const { activeExposureReadCall, getCrashGameIndex, getGameRoundByIndex, isUserBetAlready, placeBet, cashOut, getCrashPlatformFee, estimateCrashGasFee } = useCrashDataFetcher();
  const [gameStartTime, setGameStartTime] = useState(null);
  const [multiplier, setMultiplier] = useState();
  const [crashPoint, setCrashPoint] = useState(0);
  const [gameState, setGameState] = useState("waiting");
  const [betPlaced, setBetPlaced] = useState(false);
  const [betAmount, setBetAmount] = useState("");
  const [autoBetNext, setAutoBetNext] = useState(false);
  const [autoBetAmount, setAutoBetAmount] = useState("");
  const [showCashout, setShowCashout] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [countdownText, setCountdownText] = useState("");
  const [xShift, setXShift] = useState(0);
  const [yShift, setYShift] = useState(0);
  const [crashed, setCrashed] = useState(false);
  const [winPrice, setWinprice] = useState(null);
  const [winBetAmount, setWinnerBetAmount] = useState(null);
  const [winxxx, setWinnxxx] = useState(null);
  const [loading, setLoading] = useState(true);
  const [reconnectingloading, setReconnectingloading] = useState(false);
  const [loadingText, setLoadingText] = useState({
    heading: "",
    paragraph: "",
  });
  const [cashoutSpinner, setCashoutSpinner] = useState(false);
  const [placeBetSpinner, setPlaceBetSpinner] = useState(false);
  const [countDownCheck, setCounDownCheck] = useState(false);
  const [cashoutBool, setcashoutBool] = useState(false);
  const [playerHistory, setPlayerHistory] = useState([]);
  const getAllBalances = useGetAllBalances();
  const [playerBetHHistory, setPlayerBetHistory] = useState([]);
  const [indexForCRASH, setIndexForCrsh] = useState(null);
  const [recentGamesData, setRecentGamesData] = useState([]);
  const [shouldRun, setShouldRun] = useState(false);
  const { grantPermissions } = useSessionPermissions();
  const [mergedBetHistory, setMergedBetHistory] = useState([]);
  const [btnText, setBtnText] = useState("");
  const lastX = useRef(1);
  const lastY = useRef(1);
  const minBet = minBetGlobal
  const maxBetDeduction = 0.001
  const gameStartTimeGame = useRef(null);
  const gameTimeOffset = useRef(0);
  const gameUpdateLoop = useRef(null);
  const multiplierUpdateLoop = useRef(null);
  const xLabels = Array.from({ length: 5 }, (_, i) => `${1 + i + xShift}`);
  const yLabels = Array.from({ length: 5 }, (_, i) => `${1 + i + yShift}`);
  const [shouldCrashNow, setShouldCrashNow] = useState(false);
  const shouldCrashNowRef = useRef(false);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [showbet3, setShowbet3] = useState(false);
  const handleShowbet3 = () => setShowbet3(true);
  const progressPercent = countdown * 100;
  const [crashmbltab, setCrashMblTab] = useState("activity");
  const userProfile = useRecoilValue(userProfileData)
  const [userProfileOrignal, setUserProfileOrignal] = useRecoilState(userProfileData);
  const [terminationmodal, setShowterminationmodal] = useState(false);
  const handleCloseTerminationModal = () => setShowterminationmodal(false);
  const [winningsHistory, setWinningsHistory] = useState([]);
  const [estimatedGasFee, setEstimatedGasFee] = useState(0);
  const [estimatingGas, setEstimatingGas] = useState(false);
  const [cashoutEstimatedFee, setCashoutEstimatedFee] = useState(0)
  const [transectionCofirmed, setTransectionConfirmed] = useState(false)
  const gasDebounceRef = useRef(null);
  const { account } = useEoaAccount()
  const isSettingMaxRef = useRef(false);
  const [socketStatus, setSocketStatus] = useState(false)
  const events = [
    {
      eventName: "connect",
      handler: async () => {
        console.log('Connected to the server')
        if (gameState === "running" || gameState === "countdown") {
          await isGameRunningOrCrashed()
        } else {
          setReconnectingloading(false)
          setLoadingText({
            heading: t(""),
            paragraph: t(""),
          });
        }
      },
    },
    {
      eventName: "disconnect",
      handler: async () => {
        console.log('disconnecttt')
        if (isMobile) {
          setReconnectingloading(true)
          setLoadingText({
            heading: t("Reconnecting....."),
            paragraph: t(""),
          });
        }
      },
    },
    {
      eventName: "gameCrashed",
      handler: async (data) => {
        let currentDate = new Date();
        currentDate = currentDate?.getTime() / 1000;
        console.log(data, 'place crash 3rd event socket', currentDate);

        setMultiplier(convertXvalueToPercentage(data?.maxMultiplier));
        shouldCrashNowRef.current = true
        setShouldCrashNow(true);
        setShouldRun(false);
        setBetPlaced(false);
        setPendingBetAmount(0)
        setCountdown(null);
        setCashoutSpinner(false);
        setSocketStatus(false)
        setcashoutBool(false);
        setWinningsHistory([])
        maxBetHandler()
        if (betAmount) {
          let value = betAmount
          setBetAmount('');
          setTimeout(() => setBetAmount(value), 100)
        }
      },
    },
    // {
    //   eventName: "gameStarted",
    //   handler: (data) => {
    //     shouldCrashNowRef.current = false
    //     setShouldCrashNow(false)
    //     let currentDate = new Date();
    //     currentDate = currentDate?.getTime() / 1000;
    //     console.log(data, 'gameStarted 2rd event socket', currentDate);
    //     startRound(200, 0);
    //     setCountdown(null);
    //     // console.log(data, "socket gameStarted");
    //     fetchGraphChartsData();
    //   },
    // },

    {
      eventName: "gameStarted",
      handler: (data) => {
        shouldCrashNowRef.current = false
        setShouldCrashNow(false)
        startRound(200, 0);
        setCountdown(null);
        fetchGraphChartsData();
      },
    },
    {
      eventName: "roundStarted",
      handler: (data) => {
        // console.log("socket roundStarted", data);
        console.log(data, 'roundStarted 1st event');
        setShouldCrashNow(false)
        beginCountdown(7, "Loading Market", false);
        setTimeout(() => {
          fetchGraphChartsData();
        }, 2000);
        shouldCrashNowRef.current = false
      },
    },
    {
      eventName: "userEnteredRound",
      handler: (data) => {
        setWinningsHistory(prevItems => {
          const exists = prevItems.some(
            item => item.walletAddress?.toLowerCase() === data.walletAddress?.toLowerCase()
          );
          maxBetHandler()
          const placeBetAmount = web3?.utils?.fromWei(
            String(data?.amount),
            "mwei"
          );
          const v1 = (+convertBetAmountWithOutFee(+betAmount, true))?.toFixed(3)
          const v2 = (+placeBetAmount)?.toFixed(3);
          if (data.walletAddress?.toLowerCase() === smartAccount?.toLowerCase() && v2 != v1) {
            setCounDownCheck(true)
            const value = v2;
            const percent = 4;
            const result = value / (1 - percent / 100);
            console.log(result, 'open position ammount');
            setBetAmount(result?.toFixed(2))
            console.log(countDownCheck, 'countDownCheck');

          }
          if (!exists) {
            return [...prevItems, data];
          }
          return prevItems;
        });
      },
    },
    {
      eventName: "userExitRound",
      handler: async (data) => {
        if (data?.walletAddress?.toLowerCase() === smartAccount?.toLowerCase()) {
          await contractSocket(data)
        }

      },
    },

    {
      eventName: "timer",
      handler: async (data) => {
        if (!socketStatus && data.ttl <= 15 && data.ttl >= 6) {
          setSocketStatus(true)
          const value = data.ttl - 4;
          console.log(data, value, '1st event: tracking timer event');
          beginCountdown(
            value,
            "Market opens in",
            true
          );
        }
      },
    }

  ];
  useSocketEvents(events);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (!smartAccount) {
  //       navigate("/");
  //     }
  //     else if (smartAccount && !WHITE_LISTED_CRASHGAME_ADDRESSES.includes(smartAccount)) {
  //       navigate("/");
  //     }
  //   }, WHITELISTING_CHECK_TIME);
  //   return () => clearTimeout(timer);
  // }, [smartAccount, navigate]);

  const getAccurateElapsedTime = () => {
    if (!gameStartTimeGame.current) return 0;
    return (
      (performance.now() - gameStartTimeGame.current + gameTimeOffset.current) /
      1000
    );
  };

  const handleInstantCrash = () => {
    if (tlRef.current) {
      tlRef.current.kill();
      tlRef.current = null;
    }
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (gameUpdateLoop.current) {
      cancelAnimationFrame(gameUpdateLoop.current);
      gameUpdateLoop.current = null;
    }
    if (multiplierUpdateLoop.current) {
      cancelAnimationFrame(multiplierUpdateLoop.current);
      multiplierUpdateLoop.current = null;
    }
    gameStartTimeGame.current = null;
    gameTimeOffset.current = 0;
    const currentMultiplier = multiplier || 1.0;
    handleGameCrash(currentMultiplier);

  };

  useEffect(() => {
    if (shouldCrashNow) {
      handleInstantCrash();
    }
  }, [shouldCrashNow]);

  useEffect(() => {
    gsap?.ticker.lagSmoothing(0);
    gsap?.globalTimeline.paused(false);
    getCurrentGameRoundata();
    return () => {
    };
  }, []);
  useEffect(() => {
    if (smartAccount) {
      getCurrentGameRoundata1();
    }
  }, [smartAccount])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
      } else {
        if (gameState === "running" && gameStartTimeGame.current) {
          const actualElapsedTime = getAccurateElapsedTime();
          const crashAt = crashPoint || 2.0;
          const totalDuration = calculateTotalDuration(crashAt);
          if (actualElapsedTime >= totalDuration) {
            handleGameCrash(crashAt);
            return;
          }
          const current = calculateMultiplierFromTime(actualElapsedTime);
          if (shouldCrashNowRef.current) return;
          setMultiplier(current);
          updateShifts(current, actualElapsedTime);
        }
      }
    };

    const handleFocus = () => {
      if (gameState === "running" && gameStartTimeGame.current) {
        const actualTime = getAccurateElapsedTime();
        const current = calculateMultiplierFromTime(actualTime);
        setMultiplier(current);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
    };
  }, [gameState, crashPoint, multiplier]);

  const updateShifts = (currentMultiplier, elapsedTime) => {
    const newXShift = Math.max(0, Math.floor(currentMultiplier) - 1);
    const newYShift = Math.max(0, Math.floor(elapsedTime) - 1);
    if (shouldCrashNowRef.current) return;
    if (newXShift !== xShift) {
      setXShift(newXShift);
      lastX.current = Math.floor(currentMultiplier);
    }
    if (newYShift !== yShift) {
      setYShift(newYShift);
      lastY.current = Math.floor(elapsedTime);
    }
  };

  const startRound = (crashValue, stagingTime) => {
    if (shouldCrashNow) return
    setCounDownCheck(false);
    if (tlRef.current) tlRef.current.kill();
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (gameUpdateLoop.current) cancelAnimationFrame(gameUpdateLoop.current);
    if (multiplierUpdateLoop.current)
      cancelAnimationFrame(multiplierUpdateLoop.current);
    const path = pathRef.current;
    const rocket = rocketRef.current;
    const pathLength = path.getTotalLength();
    const crashAt = parseFloat(crashValue.toFixed(2));
    const totalDuration = calculateTotalDuration(crashAt);
    const elapsedTime = parseFloat(stagingTime.toFixed(2));
    gameStartTimeGame.current = performance.now();
    gameTimeOffset.current = elapsedTime * 1000;
    const remainingDuration = Math.max(0, totalDuration - elapsedTime);
    if (elapsedTime >= totalDuration) {
      handleGameCrash(crashAt);
      return;
    }
    const currentMultiplier = calculateMultiplierFromTime(elapsedTime);
    const currentProgress = elapsedTime / totalDuration;
    gsap?.set(path, {
      strokeDasharray: pathLength,
      strokeDashoffset: pathLength * (1 - currentProgress),
    });
    gsap?.set(rocket, {
      opacity: 1,
      scale: 1,
      x: 0,
      y: 0,
    });

    initializeShifts(currentMultiplier, elapsedTime);
    setCrashPoint(crashAt);
    setMultiplier(currentMultiplier);
    setGameState("running");

    if (autoBetNext && autoBetAmount) {
      setBetPlaced(true);
      setBetAmount(autoBetAmount);
      setAutoBetNext(false);
      setShowCashout(true);
    } else {
      setShowCashout(betPlaced);
    }

    const updateGameState = () => {
      if (shouldCrashNow || !gameStartTimeGame.current) { // Check ref instead
        gameUpdateLoop.current = null;
        return;
      }
      const actualElapsedTime = getAccurateElapsedTime();
      const timeProgress = actualElapsedTime / totalDuration;
      if (actualElapsedTime >= totalDuration) {
        handleGameCrash(crashAt);
        return;
      }
      const current = calculateMultiplierFromTime(actualElapsedTime);
      updateShifts(current, actualElapsedTime);
      gameUpdateLoop.current = requestAnimationFrame(updateGameState);
    };

    gameUpdateLoop.current = requestAnimationFrame(updateGameState);
    const updateMultiplierDisplay = () => {
      if (!gameStartTimeGame.current || shouldCrashNow) { // Check ref instead
        multiplierUpdateLoop.current = null;
        return;
      }
      const actualElapsedTime = getAccurateElapsedTime();
      const totalDuration = calculateTotalDuration(crashAt);
      if (actualElapsedTime >= totalDuration) {
        return;
      }
      const current = calculateMultiplierFromTime(actualElapsedTime);
      if (shouldCrashNowRef.current) return;
      setMultiplier(current);
      multiplierUpdateLoop.current = requestAnimationFrame(
        updateMultiplierDisplay
      );
    };
    multiplierUpdateLoop.current = requestAnimationFrame(
      updateMultiplierDisplay
    );
    const tl = gsap?.timeline();
    tlRef.current = tl;
    tl.to(
      path,
      {
        strokeDashoffset: 0,
        duration: Math.min(4, remainingDuration),
        ease: "power1.out",
      },
      0
    );
    tl.to(
      rocket,
      {
        duration: Math.min(4, remainingDuration),
        ease: "power1.out",
        motionPath: {
          path: path,
          align: path,
          alignOrigin: [0.5, 0.63],
          autoRotate: true,
          start: currentProgress,
          end: 1,
        },
      },
      0
    );
    if (remainingDuration > 4) {
      tl.to(
        rocket,
        {
          duration: remainingDuration - 4,
          ease: "none",
          x: "+=0",
        },
        4
      );
    }
    tl.call(
      () => {
        const actualTime = getAccurateElapsedTime();
        if (actualTime >= totalDuration && !shouldCrashNow) {
          handleGameCrash(crashAt);
        }
      },
      [],
      remainingDuration
    );
  };
  const calculateTotalDuration = (crashValue) => {
    if (crashValue <= 1) {
      return 10 * crashValue;
    } else {
      const additionalMultipliers = crashValue - 1;
      return 10 + additionalMultipliers * 5;
    }
  };

  const calculateMultiplierFromTime = (elapsedTime) => {
    if (elapsedTime <= 10) {
      return convertXvalueToPercentage(parseFloat(1 + elapsedTime / 10));
    } else if (elapsedTime <= 20) {
      const additionalTime = elapsedTime - 10;
      const additionalMultiplier = (additionalTime / 10) * 2;
      return convertXvalueToPercentage(parseFloat(2 + additionalMultiplier));
    } else {
      const t = elapsedTime;
      const multiplier = 4 * (1 + 0.039 * Math.pow(t - 20, 1.5));
      return convertXvalueToPercentage(parseFloat(multiplier));
    }
  };

  const initializeShifts = (currentMultiplier, elapsedTime) => {
    const xShiftValue = Math.max(0, Math.floor(currentMultiplier) - 1);
    const yShiftValue = Math.max(0, Math.floor(elapsedTime) - 1);
    setXShift(xShiftValue);
    setYShift(yShiftValue);
    lastX.current = Math.floor(currentMultiplier);
    lastY.current = Math.floor(elapsedTime);
  };

  const handleGameCrash = (crashAt) => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (gameUpdateLoop.current) {
      cancelAnimationFrame(gameUpdateLoop.current);
      gameUpdateLoop.current = null;
    }
    if (multiplierUpdateLoop.current) {
      cancelAnimationFrame(multiplierUpdateLoop.current);
      multiplierUpdateLoop.current = null;
    }
    gameStartTimeGame.current = null;
    gameTimeOffset.current = 0;

    setMultiplier(crashAt);
    setGameState("waiting");
    setShowCashout(false);
    setBetPlaced(false);
    setCrashed(true);
    localStorage.removeItem("AutoCashOut");
    setBtnText(t('Open Position'))
    setCashoutOtherCheck(false);
    // if (!showbet3) {
    //   handleBetLoss()
    // }
  };
  const beginCountdown = (value, value2, check) => {
    setCounDownCheck(check);

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    const startTime = Date.now();
    const duration = value * 1000;

    setCountdown(value);
    setCountdownText(value2);
    setCashoutOtherCheck(false);
    setGameState("countdown");
    setCrashed(false);

    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(
        0,
        Math.ceil((duration - elapsed) / 1000)
      );

      setCountdown(remaining);

      // if (value2 === "Market opens in" && remaining === 2) {
      //   setBetPlaced(true);
      // }

      if (value2 === "Loading Market" && remaining === 1) {
        clearInterval(intervalRef.current);
        // beginCountdown(11, "Market opens in", true);
      }

      if (remaining === 0) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }, 250); // smaller interval = smoother on mobile
  };
  const checkCrashApprovalNeeded = async () => {
    try {
      const allowanceCrash = await checkAllowance(CRASH_GAME_CONTRACT);
      const allowanceRng = await checkAllowance(RNG_CONTRACT);
      return { allowanceCrash, allowanceRng };
    } catch (error) {
      console.error("Error checking crash approvals:", error);
    }

  };

  const openPositionHandler = (e) => {
    setBetAmount(e.target.value);
  };

  useEffect(() => {
    if (isSettingMaxRef.current) {
      isSettingMaxRef.current = false;
      return;
    }

    if (!betAmount || +betAmount <= 0 || !smartAccount) {
      if (gasDebounceRef.current) {
        clearTimeout(gasDebounceRef.current);
      }

      setEstimatedGasFee(0);
      setEstimatingGas(false);
      return;
    }

    if (gasDebounceRef.current) {
      clearTimeout(gasDebounceRef.current);
    }

    setEstimatingGas(true);

    gasDebounceRef.current = setTimeout(async () => {
      try {
        const index = await getCrashGameIndex();
        const openPositionData = await getPlaceBetData(index - 1);

        const { allowanceCrash, allowanceRng } =
          await checkCrashApprovalNeeded();

        const isUSDTApprovalNeeded = +betAmount > +allowanceCrash
        const isRNGApprovalNeeded = +betAmount > +allowanceRng

        const gasFee = await estimateCrashGasFee({
          amount: betAmount,
          smartAccount,
          isUSDTApprovalNeeded,
          isRNGApprovalNeeded,
          openPositionData,
        });

        setEstimatedGasFee(gasFee);
        setEstimatingGas(false);
      } catch (err) {
        console.error("Gas estimation failed", err);
        if (gameState == "running" || countDownCheck) {
          return
        } else {
          setEstimatedGasFee(0);
          setEstimatingGas(false);
          if ((parseFloat(betAmount) && parseFloat(betAmount) >= minBet) && (parseFloat(betAmount) < parseFloat(maxBet)) && err?.code === "UNPREDICTABLE_GAS_LIMIT") {
            notifyError(t("Insufficient balance to cover gas fee"));
            return;
          }
        }
      }
    }, 600);

    return () => clearTimeout(gasDebounceRef.current);
  }, [betAmount, smartAccount]);

  const calculateMaxBetWithGasFee = async () => {
    try {
      setEstimatingGas(true);

      if (!smartAccount) {
        setEstimatingGas(false);
        setBetAmount(maxBet);
        return maxBet.toString();
      }

      const [index, { allowanceCrash, allowanceRng }] = await Promise.all([
        getCrashGameIndex(),
        checkCrashApprovalNeeded(),
      ]);

      const openPositionData = await getPlaceBetData(index - 1);
      const isUSDTApprovalNeeded = Number(allowanceCrash) === 0;
      const isRNGApprovalNeeded = Number(allowanceRng) === 0;
      const estimatedGasFee = await estimateCrashGasFee({
        amount: minBet,
        smartAccount,
        isUSDTApprovalNeeded,
        isRNGApprovalNeeded,
        openPositionData,
      });

      const balance = Number(smartAccountUsdtBalance);
      const maxAllowedBet = Number(maxBet);
      const maxAffordableBet = balance - estimatedGasFee;
      if (maxAffordableBet < minBet) {
        setEstimatedGasFee(estimatedGasFee);
        setEstimatingGas(false);
        notifyError(
          t("Your balance is not enough to cover gas fees for this transaction")
        );
        return "0";
      }
      const finalMaxBet = Math.min(maxAffordableBet, maxAllowedBet);
      setEstimatedGasFee(estimatedGasFee);
      setEstimatingGas(false);
      return finalMaxBet.toFixed(2);
    } catch (error) {
      console.error("Gas estimation failed:", error);
      setEstimatingGas(false);
      setEstimatedGasFee(null);
      return "0";
    }
  };

  const handleBetNow = async () => {
    setPlaceBetSpinner(true)
    const isSessionExists = await handleCheckSession();
    isSessionExists && setBtnText(t("Confirm in your wallet"));
    const index = await getCrashGameIndex();
    localStorage.setItem("AutoCashOut", autoCashout);
    if (!betAmount || +betAmount <= 0) return;
    try {
      const openPositionData = await getPlaceBetData(index - 1);

      const allowanceCrash = await checkAllowance(CRASH_GAME_CONTRACT);
      const allowanceRng = await checkAllowance(RNG_CONTRACT);

      const approveCrash = +betAmount > +allowanceCrash;
      const approveRng = +betAmount > +allowanceRng;

      const { userPermissions: permissions, userSessionKey: sessionKey } =
        await grantPermissions();

      const placebet = await placeBet(
        openPositionData,
        betAmount,
        index,
        { approveCrash, approveRng },
        smartAccount,
        permissions,
        sessionKey,

      );
      if (!placebet) {
        setBtnText(t("Open Position"))
      }
      if (placebet) {
        setPendingBetAmount(betAmount);
        setBetPlaced(true);
        setPlaceBetSpinner(false);
        await fetchUserUSDTBalance();
        if (isMobile) {
          window.scrollTo(0, 0)
        }

      } else {
        setPlaceBetSpinner(false);
        setPendingBetAmount(0)
      }

    } catch (error) {

      setBtnText(t('Open Position'))
      console.log("error while placing position", error);
      setPlaceBetSpinner(false);
      setPendingBetAmount(0)
      if (error?.message?.includes("Cannot destructure property 'userPermissions' of '(intermediate value)' as it is undefined.")) {
        notifyError(t("Error while open position. Please try again."));
      } else {
        notifyError(t("Too late for this round. Join the next one in a bit!"));
      }
    }
  };

  const handleBetNext = () => {
    if (!autoBetAmount || parseFloat(autoBetAmount) <= 0) return;
    setAutoBetNext(true);
  };

  const handleCashout = () => {
    if (betPlaced && !crashed) {
      parseFloat((parseFloat(betAmount) * multiplier)?.toFixed(2));
    }
    setShowCashout(false);
    setBetPlaced(false);
  };

  const handleClosebet3 = async () => {
    setShowbet3(false);
    if (!crashed) {
      setCashoutOtherCheck(true);
    } else {
      setBetPlaced(false);
      setTimeout(() => {
        balanceGraphDataHandler()
      }, 2000);
    }
    await fetchUserUSDTBalance();

    // setcashoutBool(false);
    // setWinnxxx(0)
    // setUsercashOutValue(0)
    // setIsBetLoss(false)
  };

  const fetchUserUSDTBalance = async () => {
    try {
      await getAllBalances();
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  const fetchEthBalance3 = async (starttime, induxx, crashText) => {
    let index = induxx;
    try {
      let currentDate = new Date();
      currentDate = currentDate?.getTime() / 1000;
      setGameStartTime(starttime);
      let startin = starttime - currentDate;
      startin = parseInt(startin);
      setShouldRun(true);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  const cashOutHandler = async () => {
    setcashoutBool(true);
    setCashoutSpinner(true);
    try {
      const cashOurResponseFromApi = await cashoutVerificationSignature(
        smartAccount
      );
      // console.log(cashOurResponseFromApi, 'cashout app call completed')
      const index = await getCrashGameIndex();
      // console.log(index, 'after api call getting index from contract');
      const { userPermissions: permissions, userSessionKey: sessionKey } =
        await grantPermissions();
      // console.log(sessionKey, permissions, 'after getting index permission call ');
      const { status, gasFee } = await cashOut(
        cashOurResponseFromApi,
        smartAccount,
        index - 1,
        permissions,
        sessionKey
      );
      if (status) {
        setCashoutEstimatedFee(gasFee)
        // new code
        setTransectionConfirmed(true)
      }


    } catch (error) {
      setcashoutBool(false);
      console.log('error in cashout api error>>>', error?.response?.data, 'contract error cashout>>>>>', error);
      setCashoutSpinner(false);
      if (error?.code === "INSUFFICIENT_GAS_FEE") {
        notifyError(t("Insufficient balance to cover gas fee"));
        return;
      }
      if (error?.response?.data?.data?.isCrashed) {
        notifyError(t("Cashout unsuccessful due to network delay."));
      }
      else {
        notifyError(t("Error while close position. Please try again."));
      }

    }
  };

  const fetchEthBalanceAfter = async (index) => {
    try {
      setCurrentIndex(index);
      const { amount, status } = await isUserBetAlready(smartAccount, index);
      if (!status) {
        const placeBetAmount = web3?.utils?.fromWei(
          String(amount),
          "mwei"
        );
        if (placeBetAmount > 0) {
          setPendingBetAmount(placeBetAmount)
          // last code push 
          const value = placeBetAmount / 0.96
          setBetAmount(value?.toFixed(2))
          // new code
          setTransectionConfirmed(true)
        }
      }

    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };
  const fetchPlayerHistory = async () => {
    const query = `
      query closePositionTerminations {
        closePositionTerminations(where: { user: "${smartAccount}" }
   orderBy: blockTimestamp
    orderDirection: asc
    first: 1000
        ) {
         user
    transactionHash
    timeElapsedMs
    settlement
    positionId
    marketIndexTermination
    id
    closePositionTimeMs
    blockTimestamp
    blockNumber  
        }
      }
    `;
    try {
      const data = await callCrashGameGraphQLQuery(query);
      const allPosition = data?.closePositionTerminations || [];
      const sortedHistory = allPosition?.sort(
        (a, b) => Number(b.blockTimestamp) - Number(a.blockTimestamp)
      );

      setPlayerHistory(sortedHistory);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch position history:", error);
      setLoading(false);
    }
  };

  const fetchPlayerBetHistory = async () => {
    const placedBetsQuery = `
    query openPositionTerminations {
      openPositionTerminations(where: { user: "${smartAccount}" }
        orderBy: blockTimestamp
        orderDirection: asc
        first: 1000) {
        marketIndexTermination
        amount
        blockTimestamp
        transactionHash
        blockNumber
        blockTimestamp
        user
        positionId
      }
    }
  `;

    try {
      const data = await callCrashGameGraphQLQuery(placedBetsQuery);
      const allPosition = data?.openPositionTerminations || [];
      const sortedHistory = allPosition?.sort(
        (a, b) => Number(b.blockTimestamp) - Number(a.blockTimestamp)
      );
      setPlayerBetHistory(sortedHistory);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch position history:", error);
      setLoading(false);
    }
  };
  const fetchGraphChartsData = async () => {
    const query = `
    query finalizeMarketTerminations {
      finalizeMarketTerminations(first: 1000, orderBy: blockNumber, orderDirection: desc) {
        transactionHash
        marketIndexTermination
        derivedNumber
      }
    }
  `;

    try {
      const data = await callCrashGameGraphQLQuery(query);
      const allRound = data?.finalizeMarketTerminations || [];
      setRecentGamesData(allRound);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch graph chart data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!playerHistory.length && !playerBetHHistory.length) return;
    const resolvedIndexSet = new Set(playerHistory.map((bet) => bet.marketIndexTermination));
    const merged = [];
    playerBetHHistory.forEach((placedBet) => {
      if (resolvedIndexSet.has(placedBet.marketIndexTermination)) {
        const winBet = playerHistory.find(
          (resolved) => resolved.marketIndexTermination === placedBet.marketIndexTermination
        );

        if (winBet) {
          merged.push({
            ...winBet,
            type: "win",
            amount: placedBet?.amount
          });
        }
      } else {
        merged.push({
          ...placedBet,
          type: "loss",
        });
      }
    });
    setMergedBetHistory(merged);
  }, [playerHistory, playerBetHHistory]);

  useEffect(() => {
    if (gameState == "waiting") {
      if (smartAccount) {
        setTimeout(() => {
          fetchUserUSDTBalance();
          fetchPlayerHistory();
          fetchPlayerBetHistory();
          maxBetHandler();
          fetchGraphChartsData();
        }, 5000);
      } else {
        maxBetHandler();
        fetchGraphChartsData();
      }
    }
  }, [smartAccount, gameState]);


  useEffect(() => {
    if (cashoutSaved) {
      setAutoCashOut(cashoutSaved);
    }
  }, [cashoutSaved]);


  const isGameRunningOrCrashed = async () => {
    const index = await getCrashGameIndex();
    const currentRound = await getGameRoundByIndex(index - 1);
    const isGameCrashed = await getIsGameInProgress(
      currentRound.startTime,
      currentRound.encryptedSalt,
      index - 1
    );
    if (isGameCrashed?.isCrashed) {
      setMultiplier(convertXvalueToPercentage(isGameCrashed?.xMax));
      setShouldCrashNow(true);
      shouldCrashNowRef.current = true
      setShouldRun(false);
      setBetPlaced(false);
      setPendingBetAmount(0)
      setCountdown(null);
      setCashoutSpinner(false);
      setSocketStatus(false)
      setCounDownCheck(false);

      setWinningsHistory([])
    } else {
      const startin = isGameCrashed?.myTime - currentRound.startTime;
      startRound(200, startin <= 0 ? 0 : startin);
      setShouldRun(true);
      fetchEthBalanceAfter(index);
      shouldCrashNowRef.current = false
      setShouldCrashNow(false)
      setCountdown(null);
    }
    setReconnectingloading(false)
    setLoadingText({
      heading: t(""),
      paragraph: t(""),
    });
  }


  const getCurrentGameRoundata = async () => {
    setLoading(true);
    try {
      let index = await getCrashGameIndex();
      let checkindex = index;
      index = index > 0 ? index - 1 : index;
      let currentRount = await getGameRoundByIndex(index);
      if (checkindex > 0) {
        let currentDate = new Date();
        setGameStartTime(currentRount.startTime);
        let value = 100;
        value = value - 10;
        value = value / 5;
        value = value + 1;
        let isGameCrashed = await getIsGameInProgress(
          currentRount.startTime,
          currentRount.encryptedSalt,
          index
        );
        if (isGameCrashed?.isCrashed) {
          fetchEthBalanceAfter(checkindex == 0 ? 0 : index + 1);
        } else {
          const startin = isGameCrashed?.myTime - currentRount.startTime
          startRound(200, startin <= 0 ? 0 : startin);
          setShouldRun(true);
          fetchEthBalanceAfter(checkindex == 0 ? 0 : index);
        }
      } else {
        fetchEthBalanceAfter(checkindex == 0 ? 0 : index);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching ETH balance:", error);
    }
  };
  const getCurrentGameRoundata1 = async () => {
    try {
      let index = await getCrashGameIndex();
      let checkindex = index;
      index = index > 0 ? index - 1 : index;
      let currentRount = await getGameRoundByIndex(index);
      if (checkindex > 0) {
        let currentDate = new Date();
        currentDate = currentDate?.getTime() / 1000;
        let startin = currentDate - currentRount.startTime;
        setGameStartTime(currentRount.startTime);
        let value = 100;
        value = value - 10;
        value = value / 5;
        value = value + 1;
        let isGameCrashed = await getIsGameInProgress(
          currentRount.startTime,
          currentRount.encryptedSalt
          , index
        );
        if (isGameCrashed?.isCrashed) {
          fetchEthBalanceAfter(checkindex == 0 ? 0 : index + 1);
        } else {
          fetchEthBalanceAfter(checkindex == 0 ? 0 : index);
        }
      } else {
        fetchEthBalanceAfter(checkindex == 0 ? 0 : index);
      }
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  const handleChange = (e) => {
    const input = e.target.value;
    if (input === "") {
      setAutoCashOut("");
      return;
    }
    if (input < minBet) {
      setAutoCashOut("");
      return;
    }
    if (!/^\d*$/.test(input)) return;
    if (+input === 1) {
      notifyWarning(t("Limit order must be greater than 1%."));
    }
    if (+input >= 9900) {
      notifyWarning(t("Limit order must be less than 9900%."));
      return
    }
    setAutoCashOut(input);
  };

  const handleBetLoss = async () => {
    const index = await getCrashGameIndex();
    const placeBet = await isUserBetAlready(smartAccount, index - 1);
    const placeBetAmount = web3?.utils?.fromWei(
      String(placeBet?.amount),
      "mwei"
    );
    if (placeBetAmount > 0) {
      setUsercashOutValue(multiplier)
      setIsBetLoss(true)
      handleShowbet3()
    } else {
      setIsBetLoss(false)
    }
  }

  const balanceGraphDataHandler = async () => {
    try {
      // await getCurrentGameRoundata();
      await fetchPlayerHistory();
      await fetchPlayerBetHistory();
      await maxBetHandler();
      await fetchGraphChartsData();
    } catch (err) {
      console.log(err, 'all data err');

    }
  }
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  useEffect(() => {
    if (userProfile && !userProfile?.riskMarketDisclaimer) {
      setShowterminationmodal(true)
    }
  }, [userProfile])

  const riskMarketDisclaimerApi = async () => {
    try {
      if (isChecked) {
        setLoading(true)
        const apiResponse = await postMarketDisclaimer()
        if (apiResponse) {
          handleCloseTerminationModal()
          setUserProfileOrignal((prev) => ({
            ...prev,
            riskMarketDisclaimer: true,
          }));
        }
        setLoading(false)
      } else {
        handleCloseTerminationModal()
      }
    } catch (err) {
      setLoading(false)
      console.log(err, 'err api');

    }
  }

  const contractSocket = (cashOutData) => {
    // // new code
    // if (transectionCofirmed) {
    const amount = web3?.utils?.fromWei(String(cashOutData?.amount), "mwei");
    const betPlaceAmount = (+betAmount) * 0.96;
    const pendingBet = pendingBetAmount
    const amount1 = betPlaceAmount ? betPlaceAmount : pendingBet
    const result = (+amount) / (+amount1);
    const userPnl = (+amount) - (+amount1)
    setWinnxxx(result);
    setWinprice(userPnl);
    setWinnerBetAmount(amount1)
    setPendingBetAmount(0)
    handleCashout();
    handleShowbet3();
    setBetPlaced(false);
    setCashoutSpinner(false);
    setTransectionConfirmed(false)
    // }
  }

  useEffect(() => {
    if (pendingBetAmount > 0 && !cashoutBool && (+autoCashout) > 1 && (+multiplier) >= (+autoCashout) && (+autoCashout) < 9900) {
      setcashoutBool(true);
      autoCashOutHandler();
    }
  }, [multiplier]);
  const autoCashOutHandler = async () => {
    setcashoutBool(true);
    setCashoutSpinner(true);
    try {
      const cashOurResponseFromApi = await autoCashoutVerificationSignature(
        smartAccount
      );
      // console.log(cashOurResponseFromApi, 'cashout app call completed')
      const index = await getCrashGameIndex();
      // console.log(index, 'after api call getting index from contract');
      const { userPermissions: permissions, userSessionKey: sessionKey } =
        await grantPermissions();
      // console.log(sessionKey, permissions, 'after getting index permission call ');
      const { status, gasFee } = await cashOut(
        cashOurResponseFromApi,
        smartAccount,
        index - 1,
        permissions,
        sessionKey
      );
      if (status) {
        setCashoutEstimatedFee(gasFee)
        // new code
        setTransectionConfirmed(true)
      }


    } catch (error) {
      setcashoutBool(false);
      console.log('error in cashout api error>>>', error?.response?.data, 'contract error cashout>>>>>', error);
      setCashoutSpinner(false);
      if (error?.code === "INSUFFICIENT_GAS_FEE") {
        notifyError(t("Insufficient balance to cover gas fee"));
        return;
      }
      if (error?.response?.data?.data?.isCrashed) {
        notifyError(t("Cashout unsuccessful due to network delay."));
      }
      else {
        notifyError(t("Error while close position. Please try again."));
      }

    }
  };


  const maxButtonHAndler = async () => {
    const maxAmountWithGas = await calculateMaxBetWithGasFee();
    isSettingMaxRef.current = true;
    setBetAmount(maxAmountWithGas);
  }


  // useEffect(() => {
  //   let isActive = true; // flag

  //   const provider = new ethers.WebSocketProvider(ALCHEMY_RPC_URL);
  //   const contract = new ethers.Contract(
  //     CRASH_GAME_CONTRACT,
  //     CrashGameABI,
  //     provider
  //   );

  //   const handleBetResolved = (
  //     marketIndexTermination,
  //     startTime,
  //     randomNumber,
  //     encryptedSalt,
  //     rows,
  //     requestId,
  //   ) => {
  //     if (!isActive) return; // agar cleanup ho chuka hai toh ignore karo

  //     let currentDate = new Date();
  //     currentDate = currentDate?.getTime() / 1000;

  //     console.log(marketIndexTermination, startTime, randomNumber, encryptedSalt, rows, requestId, currentDate, 'StartMarketTermination contract event');
  //   };

  //   contract.on("StartMarketTermination", handleBetResolved);

  //   return () => {
  //     isActive = false; // flag off
  //     contract.off("StartMarketTermination", handleBetResolved);
  //     setTimeout(() => provider.destroy(), 500); // thoda delay do
  //   };

  // }, [smartAccount]);

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Risk Market",
    operatingSystem: "Web-based",
    applicationCategory: "BusinessApplication",
    description: "Risk Market by Rain is an AI-driven platform designed to identify, analyze, and mitigate market risks through advanced predictive modeling and real-time data analysis.",
    url: "https://www.rain.one/apps/risk-market",
    publisher: {
      "@type": "Organization",
      name: "Rain",
      url: "https://www.rain.one"
    },
    screenshot: "https://www.rain.one/assets/app/1.png",
    featureList: [
      "Market Risk Identification",
      "AI-Powered Risk Analysis",
      "Real-time Threat Monitoring",
      "Strategic Mitigation Insights"
    ]
  };

  const maxBetHandler = async () => {
    try {
      const liquidity = await TotalLiquidityHook(
        getGameLiquidityContract,
        LIQUIDITY_CONTRACT
      );
      const liquidityPlatformFee = await getCrashPlatformFee();
      const currentRound = await activeExposureReadCall();
      let totalAssets = convertFromWei(currentRound.totalAssets, "mwei")
      const calculateMaxBet = ((+liquidity) - (+liquidityPlatformFee) - (+totalAssets)) / 475
      setMaxBet(formatSmartDecimal(calculateMaxBet));
      setTotalLiquidity(liquidity)
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  }
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(softwareSchema)}
        </script>
      </Helmet>
      {reconnectingloading && <ReconnectingLoader text={loadingText} />}
      {loading && <LiquidityLoader text={loadingText} />}
      <section className="moonmain">
        <div className="custom-container p-0">
          <div className="moonupper">
            <div className="upperleft">
              <div className="main-heading">
                <div className="left-head">
                  <h4 className="crashhead">{t('Risk Market')}</h4>
                  <a className="btn-how" onClick={() => setShowterminationmodal(true)}>{t('How it works')} {
                    theme != LIGHT_THEME ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8 11.3333V11.34M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8Z" stroke="#DAD9D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M7.99935 9.00076C7.98707 8.78434 8.04545 8.5698 8.16569 8.38944C8.28593 8.20907 8.46152 8.07267 8.66602 8.00076C8.9166 7.90494 9.14152 7.75225 9.32306 7.55473C9.50461 7.35721 9.63783 7.12024 9.71223 6.86249C9.78664 6.60473 9.80019 6.33322 9.75183 6.06934C9.70348 5.80545 9.59453 5.55639 9.43356 5.34177C9.27259 5.12715 9.064 4.95282 8.82421 4.83251C8.58442 4.7122 8.31998 4.64919 8.0517 4.64844C7.78342 4.6477 7.51863 4.70924 7.27818 4.82822C7.03773 4.9472 6.82817 5.12037 6.66602 5.33409" stroke="#DAD9D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8 11.3333V11.34M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8Z" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M7.99984 9.00076C7.98756 8.78434 8.04594 8.5698 8.16618 8.38944C8.28642 8.20907 8.46201 8.07267 8.6665 8.00076C8.91709 7.90494 9.142 7.75225 9.32355 7.55473C9.5051 7.35721 9.63832 7.12024 9.71272 6.86249C9.78712 6.60473 9.80068 6.33322 9.75232 6.06934C9.70397 5.80545 9.59501 5.55639 9.43405 5.34177C9.27308 5.12715 9.06449 4.95282 8.8247 4.83251C8.58491 4.7122 8.32047 4.64919 8.05219 4.64844C7.78391 4.6477 7.51912 4.70924 7.27867 4.82822C7.03821 4.9472 6.82866 5.12037 6.6665 5.33409" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  } </a>
                </div>
                <p className="para">{t('Test your market intuition.')} <br /> {t('Watch the profit grow, but act fast.')}</p>
              </div>

              <div className="leftupper">
                <div className="upperinnerleft">
                  <h6 className="market-text">{t('Market History')}</h6>
                  {recentGamesData?.slice(0, isMobile ? 3 : 10
                  ).reverse()?.map((item, index) => {
                    const rawValue = parseFloat(10000 / item?.derivedNumber);
                    const randomEth = rawValue;

                    let circleClass = "greencircle";
                    let textClass = "greentext";

                    if (randomEth > 2 && randomEth <= 10) {
                      circleClass = "yellowcircle";
                      textClass = "yellowtext";
                    } else if (randomEth > 10) {
                      circleClass = "purplecircle";
                      textClass = "purpletext";
                    }
                    return (
                      <div className="upperinner" key={index}>
                        <span className={`circle ${circleClass}`}></span>
                        <div className="innertexts">
                          <h6 className={`innerhead ${textClass}`}>
                            {isFinite(randomEth)
                              ? `${formatNumberWithCommas((convertXvalueToPercentage(randomEth)))}%`
                              : "0%"}
                          </h6>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <Dropdown
                  className="upperdropdown"
                  align="end"
                  show={show}
                  onToggle={() => setShow((prev) => !prev)}
                >
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    onClick={() => setShow(!show)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M2.5 10C2.5 11.4834 2.93987 12.9334 3.76398 14.1668C4.58809 15.4001 5.75943 16.3614 7.12987 16.9291C8.50032 17.4968 10.0083 17.6453 11.4632 17.3559C12.918 17.0665 14.2544 16.3522 15.3033 15.3033C16.3522 14.2544 17.0665 12.918 17.3559 11.4632C17.6453 10.0083 17.4968 8.50032 16.9291 7.12987C16.3614 5.75943 15.4001 4.58809 14.1668 3.76398C12.9334 2.93987 11.4834 2.5 10 2.5C7.90329 2.50789 5.89081 3.32602 4.38333 4.78333L2.5 6.66667"
                        stroke="#F24CA2"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.5 2.5V6.66667H6.66667"
                        stroke="#F24CA2"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10 5.8335V10.0002L13.3333 11.6668"
                        stroke="#F24CA2"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <div className="dropmain">
                      <div className="drophead">
                        <h6 className="dropheading">{t('Market History')}</h6>
                        <button
                          className="closebtn"
                          onClick={() => setShow(false)}
                        >
                          {
                            theme === LIGHT_THEME ? <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              className="lightsvg"
                            >
                              <path
                                d="M18 6L6 18"
                                stroke="#13151A"
                                stroke-width="1.25"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6 6L18 18"
                                stroke="#13151A"
                                stroke-width="1.25"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg> : <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              className="darksvg"
                            >
                              <path
                                d="M18 6L6 18"
                                stroke="white"
                                stroke-width="1.25"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6 6L18 18"
                                stroke="white"
                                stroke-width="1.25"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          }
                        </button>
                      </div>
                      <div className="midbody">
                        <h6><span style={{ background: "#F9AD51" }}></span>1% - 100%</h6>
                        <h6><span style={{ background: "#00BB96" }}></span>101% - 900%</h6>
                        <h6><span style={{ background: "#8559E3" }}></span>901% - 9900%</h6>
                      </div>
                      <div className="dropbody">
                        <div className="maintable">
                          <table>
                            <thead>
                              {/* <th>ID</th> */}
                              <th>{t('Result')}</th>
                              <th>{t('Hash')}</th>
                            </thead>
                            <tbody>
                              {recentGamesData?.map((item, index) => {
                                const rng = parseFloat(10000 / item?.derivedNumber); // <- direct use of rng
                                let color = "green";

                                if (rng > 2 && rng <= 10) {
                                  color = "yellow";
                                } else if (rng > 10) {
                                  color = "purple";
                                }
                                const txHash = item.transactionHash;
                                const shortTx = `${txHash?.slice(
                                  0,
                                  6
                                )}...${txHash?.slice(-4)}`;

                                return (
                                  <tr key={index}>
                                    {/* <td>
                                      <div className="mainnumber">
                                        <span
                                          className={`circle ${color}`}
                                        ></span>
                                        <p
                                          className={`numberpara ${color}text`}
                                        >
                                          {item.indexId}
                                        </p>
                                      </div>
                                    </td> */}
                                    <td>
                                      <div className="mainnumber">
                                        <span
                                          className={`circle ${color}`}
                                        ></span>
                                        <p
                                          className={`numberpara ${color}text`}
                                        >
                                          {isFinite(rng)
                                            ? `${formatNumberWithCommas(convertXvalueToPercentage(rng))}%`
                                            : "0%"}
                                        </p>
                                      </div>

                                    </td>
                                    <td>
                                      <a className="mainlink" href={`${arbiscan_url}/${txHash}`} target="_blank">{shortTx} <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <g clip-path="url(#clip0_9211_4351)">
                                          <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#75768F" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M10.5 1.5L6 6" stroke="#75768F" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M7.5 1.5H10.5V4.5" stroke="#75768F" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_9211_4351">
                                            <rect width="12" height="12" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg></a>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
                <button className="mobilesidebtn d-none" onClick={handleShow1}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M2.5 10C2.5 11.4834 2.93987 12.9334 3.76398 14.1668C4.58809 15.4001 5.75943 16.3614 7.12987 16.9291C8.50032 17.4968 10.0083 17.6453 11.4632 17.3559C12.918 17.0665 14.2544 16.3522 15.3033 15.3033C16.3522 14.2544 17.0665 12.918 17.3559 11.4632C17.6453 10.0083 17.4968 8.50032 16.9291 7.12987C16.3614 5.75943 15.4001 4.58809 14.1668 3.76398C12.9334 2.93987 11.4834 2.5 10 2.5C7.90329 2.50789 5.89081 3.32602 4.38333 4.78333L2.5 6.66667"
                      stroke="#F24CA2"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.5 2.5V6.66667H6.66667"
                      stroke="#F24CA2"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10 5.8335V10.0002L13.3333 11.6668"
                      stroke="#F24CA2"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <div className="crashgame">
                <h1
                  className={crashed ? "multiplier red" : "multiplier"}
                  style={{
                    visibility:
                      gameState === "countdown" ? "hidden" : "visible",
                  }}
                >
                  {multiplier ? formatNumberWithCommas(multiplier) : "0.00"}
                  % <br />
                  {crashed && <span className="crashspan">{t('Market Closed')}</span>}
                </h1>
                {gameState === "countdown" && (
                  <div className="progressbarr">
                    <div
                      className="innerprogress"
                      style={{
                        width: "150%",
                        transition: "width 1s linear",
                      }}
                    ></div>
                    <p className="progresspara">
                      {countdownText}
                      {countdownText === "Loading Market" ?

                        "" :
                        countdown ? ` ${countdown}s` : ''}

                    </p>
                  </div>
                )}
                <div className="innercrashgame">
                  <div className="x-axis">
                    {xLabels.map((val, idx) => (
                      <span className="xnumber" key={idx}>
                        {`${formatNumberWithCommas(val)}%`}
                      </span>
                    ))}
                  </div>
                  <div className="rightgraph">
                    <div className="linemain">
                      <div
                        className="maininnerline"
                        style={{
                          visibility:
                            gameState === "countdown" ? "hidden" : "visible",
                        }}
                      >
                        {window.innerWidth < 600 ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="638"
                            height="403"
                            viewBox="0 0 638 403"
                            fill="none"
                            className="lineinner"
                          >
                            <g filter="url(#filter0_d_2309_31)">
                              <path
                                d="M20 377.934C20 377.934 260.575 367.068 387.576 275.798C518.519 181.696 620 13 620 13"
                                stroke-width="4"
                                stroke-linecap="round"
                                ref={pathRef}
                                stroke={crashed ? "var(--logout-text)" : "#22AB00"}
                              />
                            </g>
                            <defs>
                              <filter
                                id="filter0_d_2309_31"
                                x="0"
                                y="0"
                                width="638"
                                height="402.934"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                />
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                />
                                <feOffset dx="-1" dy="6" />
                                <feGaussianBlur stdDeviation="8.5" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix
                                  type="matrix"
                                  values={
                                    crashed
                                      ? "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 1 0"
                                      : "0 0 0 0 0.133333 0 0 0 0 0.670588 0 0 0 0 0 0 0 0 1 0"
                                  }
                                />
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_2309_31"
                                />
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_2309_31"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="782"
                            height="298"
                            viewBox="0 0 782 298"
                            fill="none"
                            className="lineinner"
                          >
                            <g filter="url(#filter0_d_2309_31)">
                              <path
                                d="M20.0002 273C20.0002 273 264.638 236.456 413 184C556.755 133.173 764 13 764 13"
                                stroke-width="4"
                                stroke-linecap="round"
                                ref={pathRef}
                                stroke={crashed ? "var(--logout-text)" : "#22AB00"}
                              />
                            </g>
                            <defs>
                              <filter
                                id="filter0_d_2309_31"
                                x="0"
                                y="0"
                                width="782.001"
                                height="298"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                />
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                />
                                <feOffset dx="-1" dy="6" />
                                <feGaussianBlur stdDeviation="8.5" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix
                                  type="matrix"
                                  values={
                                    crashed
                                      ? "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 1 0"
                                      : "0 0 0 0 0.133333 0 0 0 0 0.670588 0 0 0 0 0 0 0 0 1 0"
                                  }
                                />
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_2309_31"
                                />
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_2309_31"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        )}
                      </div>
                      <div className="innerlines">
                        {[...Array(5)].map((_, i) => (
                          <div className="innerborder" key={i}></div>
                        ))}
                      </div>
                    </div>
                    <div className="y-axis">
                      {yLabels.map((val, idx) => (
                        <span className="xnumber" key={idx}>
                          {`${(val)}s`}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>


              {/* <h5 className="playhead">Play the Game</h5>
              <div className="minmax">
                <p className="dullpara">
                  Min Trade
                  <span className="dollarahead">$1</span>
                </p>
                <p className="dullpara">
                  Max Trade
                  <span className="dollarahead">{maxBet?.toFixed(2)}</span>
                </p>
              </div> */}

            </div>
            <div className="right-side-new">
              <div className="leftlow">
                {/* gameState === "waiting" || countdownText === "Market opens in" */}
                {(isMobile ? gameState === "waiting" || countdownText === "Loading Market" : true) &&

                  <>
                    <div className="minmax">
                      <p className="dullpara">
                        {t('Min Position')}
                        <span className="dollarahead">${formatSmartDecimal(minBet)}</span>
                      </p>
                      <p className="dullpara">
                        {t('Max Position')}
                        <span className="dollarahead">${formatSmartDecimal(maxBet)}</span>
                      </p>
                      <OverlayTrigger
                        placement="top"
                        trigger={['hover', 'focus']}
                        delay={{ show: 100, hide: 1500 }}
                        rootClose={false}
                        overlay={
                          <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                            <p>{t('Minimum and maximum trade amounts are based on the size of the')} <Link to="/liquidity">{t('liquidity pool')}</Link>.</p>
                          </TooltipCustom>
                        }
                      >
                        <svg style={{ marginTop: "-1px" }} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <g clip-path="url(#clip0_10136_49160)">
                            <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_10136_49160">
                              <rect width="14" height="14" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </OverlayTrigger>
                    </div>
                    <div className="lowinner">
                      <div className="amountupper">
                        <p className="amountpara">{t('Amount')}{" "}
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                <p>{t('Enter the trade amount for this position.')}</p>
                              </TooltipCustom>
                            }
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                              <g clip-path="url(#clip0_10136_49160)">
                                <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </g>
                              <defs>
                                <clipPath id="clip0_10136_49160">
                                  <rect width="14" height="14" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </OverlayTrigger>
                        </p>

                        <p className="amountpara">
                          {t('Balance')}:{" "}
                          <span className="mainamount">
                            {" "}
                            {formatSmartDecimal(+smartAccountUsdtBalance)} USDT
                          </span>
                        </p>
                      </div>
                      <div className="maininput">
                        <input
                          placeholder="0"
                          onWheel={(e) => e.target.blur()}
                          value={betAmount}
                          disabled={(+pendingBetAmount) > 0 || placeBetSpinner || betPlaced}
                          onChange={openPositionHandler}
                          type="number"
                          className={
                            (!pendingBetAmount || gameState == "waiting") && ((parseFloat(betAmount) && parseFloat(betAmount) < minBet) ||
                              parseFloat(betAmount) > smartAccountUsdtBalance && smartAccountUsdtBalance > 0 ||
                              parseFloat(betAmount) > parseFloat(maxBet))
                              ? "inputinner error"
                              : "inputinner"
                          }
                        />
                        <img
                          src="/assets/usdt-iconwitharb.svg"
                          alt="tokenimg"
                          className="tokenimg"
                        />
                        {(!pendingBetAmount || gameState == "waiting") &&
                          <>
                            {(parseFloat(betAmount) && parseFloat(betAmount) < minBet) ?
                              <p className="error-text-input">{t('Position size must be at least')} ${formatSmartDecimal(minBet)}</p>
                              :
                              <>
                                {parseFloat(betAmount) > parseFloat(maxBet) ?
                                  <p className="error-text-input">{t('Position size must not exceed')} ${formatSmartDecimal(maxBet)}</p>


                                  :
                                  <>
                                    {parseFloat(betAmount) > smartAccountUsdtBalance && smartAccountUsdtBalance > 0 ?
                                      <p className="error-text-input">{t('You don’t the minimum balance required to open a position.')} ${formatSmartDecimal(smartAccountUsdtBalance)} </p>
                                      :
                                      ""

                                    }
                                  </>

                                }
                              </>

                            }
                          </>}

                      </div>


                      <div className="buttonsmain">
                        <button
                          disabled={placeBetSpinner || betPlaced || (+pendingBetAmount) > 0}
                          className="innerbtn"
                          onClick={() => {

                            setBetAmount(10);
                          }}
                        >
                          10
                        </button>
                        <button
                          disabled={placeBetSpinner || betPlaced || (+pendingBetAmount) > 0}
                          className="innerbtn"
                          onClick={() => {
                            setBetAmount(100);
                          }}
                        >
                          100
                        </button>
                        <button
                          disabled={placeBetSpinner || betPlaced || (+pendingBetAmount) > 0}
                          className="innerbtn"
                          onClick={() => {
                            setBetAmount(1000);
                          }}
                        >
                          1,000
                        </button>
                        {/* <button
                          className="innerbtn"
                          disabled={placeBetSpinner || betPlaced || (+pendingBetAmount) > 0}
                          onClick={maxButtonHAndler}
                        >
                          {t('MAX')}
                        </button> */}
                      </div>
                    </div>
                    <div className="lowinner">
                      <div className="amountupper">
                        <p className="amountpara">Limit Order</p>
                      </div>
                      <div className="maininput">
                        <input
                          value={autoCashout}
                          disabled={placeBetSpinner || betPlaced || pendingBetAmount > 0}
                          onWheel={(e) => e.target.blur()}
                          placeholder="0"
                          type="number"
                          className="inputinner"
                          onChange={handleChange}
                        />
                      </div>
                      <div className="buttonsmain">
                        <button
                          disabled={placeBetSpinner || betPlaced || pendingBetAmount > 0}
                          className="innerbtn"
                          onClick={() => {
                            setAutoCashOut(25);
                          }}
                        >
                          25%
                        </button>
                        <button
                          disabled={placeBetSpinner || betPlaced || pendingBetAmount > 0}
                          className="innerbtn"
                          onClick={() => {
                            setAutoCashOut(50);
                          }}
                        >
                          50%
                        </button>
                        <button
                          disabled={placeBetSpinner || betPlaced || pendingBetAmount > 0}
                          className="innerbtn"
                          onClick={() => {
                            setAutoCashOut(100);
                          }}
                        >
                          100%
                        </button>
                        <button
                          disabled={placeBetSpinner || betPlaced || pendingBetAmount > 0}
                          className="innerbtn"
                          onClick={() => {
                            setAutoCashOut(200);
                          }}
                        >
                          200%
                        </button>
                      </div>
                    </div>
                    <div className="multi-values">
                      <div className="text">
                        <p>{t('Estimated Network Fee')} <OverlayTrigger
                          placement="top"
                          trigger={['hover', 'focus']}
                          delay={{ show: 100, hide: 1500 }}
                          rootClose={false}
                          overlay={
                            <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                              <p>{t('This is an estimate based on current network conditions.')} <br /><br />
                                {t('The actual network fee is determined when you close your position and may be higher or lower.')}</p>
                            </TooltipCustom>
                          }
                        >
                          <svg style={{ marginTop: "-1px" }} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <g clip-path="url(#clip0_10136_49160)">
                              <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_10136_49160">
                                <rect width="14" height="14" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </OverlayTrigger> </p>
                        <h6>
                          {estimatingGas ? (
                            <span
                              className="spinner m-0"
                              style={{ width: "10px", height: "10px" }}
                            />
                          ) : (
                            estimatedGasFee > 0 ? (
                              `$${formatSmartDecimal(estimatedGasFee)}`
                            ) : "$0.00"
                          )}
                        </h6>


                      </div>
                      <div className="text">
                        <p>{t('Platform Fee')} (4%)</p>
                        <h6>${convertBetAmountWithOutFee(+betAmount)}</h6>
                      </div>
                      <div className="text">
                        <p>{t('Effective Amount')}</p>
                        <h6>${convertBetAmountWithOutFee(+betAmount, true)}</h6>
                      </div>
                    </div>
                  </>
                }
                {smartAccount ? (
                  <>
                    {!countDownCheck ? (
                      <>
                        {(gameState === "waiting" &&
                          !betPlaced &&
                          pendingBetAmount == 0) ||
                          (!betPlaced &&
                            pendingBetAmount == 0 &&
                            gameState === "countdown") ? (
                          <button
                            onClick={handleBetNow}
                            disabled={

                              !betAmount || placeBetSpinner ||
                                parseFloat(betAmount) < minBet ||
                                parseFloat(betAmount) > smartAccountUsdtBalance || !estimatedGasFee || estimatingGas ||
                                parseFloat(betAmount) > parseFloat(maxBet)
                                ? true
                                : false
                            }
                            className="betbtn"
                          >

                            {placeBetSpinner && btnText === '' ? (
                              <span className="spinner" />
                            ) : (
                              <span className="">{btnText || t("Open Position")}</span>
                            )}
                          </button>
                        ) : (
                          <>
                            {gameState === "running" && pendingBetAmount > 0 ? (
                              <button
                                disabled={cashoutSpinner}
                                onClick={() => {
                                  cashOutHandler();
                                }}
                                className="cashoutbtn"
                              >
                                <span className="dollars"></span>
                                {cashoutSpinner ? <span className="spinner" /> :
                                  <>
                                    ${betAmount ? calculationForPayOut(multiplier, betAmount) : calculationForPayOut(multiplier, (+pendingBetAmount))}
                                    <br />
                                    {t('Close Position')}
                                  </>}
                              </button>
                            ) : (
                              <>
                                {gameState === "running" && pendingBetAmount == 0 ? (
                                  <button
                                    disabled={true}
                                    onClick={handleBetNext}
                                    className="betbtn"
                                  >
                                    {t('Open position in next market')}
                                  </button>

                                ) : (
                                  <button
                                    disabled={true}
                                    onClick={handleBetNext}
                                    className="betbtn"
                                  >
                                    {t('Initializing Market')}
                                  </button>

                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {pendingBetAmount > 0 ? (
                          <button
                            disabled={true}
                            onClick={handleBetNext}
                            className="betbtn"
                          >
                            {t('Your position is open')}
                          </button>
                        )
                          : (
                            <button
                              disabled={true}
                              onClick={handleBetNext}
                              className="betbtn"
                            >
                              {t('Open position in next market')}
                            </button>
                          )
                        }
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <button
                      className="betbtn"
                      disabled={true}
                      onClick={handleShow11}
                    >
                      {t('Please connect your wallet')}
                    </button>
                  </>
                )}
              </div>
              <div className="totalpoolliquidity">
                <div className="left-text">
                  <p>{t('Total Pool Liquidity')}</p>
                  <h6>${formatNumbers(+totalLiquidity)}</h6>
                </div>
                <Link to="/liquidity" className="btn-add">{t('Add')} <svg xmlns="http://www5w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.12078 3.34691C8.69901 3.06145 11.3009 3.06145 13.8791 3.34691C15.3066 3.50691 16.4583 4.63107 16.6258 6.06357C16.9313 8.67857 16.9313 11.3202 16.6258 13.9352C16.4583 15.3677 15.3066 16.4919 13.8791 16.6519C11.3009 16.9374 8.69901 16.9374 6.12078 16.6519C4.69328 16.4919 3.54161 15.3677 3.37411 13.9352C3.06866 11.3205 3.06866 8.67913 3.37411 6.06441C3.45883 5.36847 3.77609 4.72153 4.27447 4.22845C4.77285 3.73536 5.42314 3.42503 6.11994 3.34774M9.99994 5.83857C10.1657 5.83857 10.3247 5.90442 10.4419 6.02163C10.5591 6.13884 10.6249 6.29781 10.6249 6.46357V9.37441H13.5358C13.7015 9.37441 13.8605 9.44026 13.9777 9.55747C14.0949 9.67468 14.1608 9.83365 14.1608 9.99941C14.1608 10.1652 14.0949 10.3241 13.9777 10.4413C13.8605 10.5586 13.7015 10.6244 13.5358 10.6244H10.6249V13.5352C10.6249 13.701 10.5591 13.86 10.4419 13.9772C10.3247 14.0944 10.1657 14.1602 9.99994 14.1602C9.83418 14.1602 9.67521 14.0944 9.558 13.9772C9.44079 13.86 9.37494 13.701 9.37494 13.5352V10.6244H6.46411C6.29835 10.6244 6.13938 10.5586 6.02217 10.4413C5.90496 10.3241 5.83911 10.1652 5.83911 9.99941C5.83911 9.83365 5.90496 9.67468 6.02217 9.55747C6.13938 9.44026 6.29835 9.37441 6.46411 9.37441H9.37494V6.46357C9.37494 6.29781 9.44079 6.13884 9.558 6.02163C9.67521 5.90442 9.83418 5.83857 9.99994 5.83857Z" fill="#212121" />
                </svg></Link>
              </div>
            </div>
          </div>


          {
            window.innerWidth < 991 ? <><div className="tabs-twice">
              <a className={crashmbltab === 'activity' ? "active" : ""} onClick={() => setCrashMblTab("activity")}>{t('Activity')}</a>
              <a className={crashmbltab === 'myposition' ? "active" : ""} onClick={() => setCrashMblTab("myposition")}>{t('My Positions')}</a>

            </div></> : ""
          }


          <div className="bottom-new-twice-section">
            {
              (window.innerWidth < 991 ? crashmbltab === "myposition" : true) && <>
                {window.innerWidth > 991 ? (
                  <div className="history-section">
                    <h4 className="heading-text">{t('My Positions')}</h4>
                    <div className="parent">
                      <div className="upper-fields">
                        <p>{t('Tx Hash')}</p>
                        <p>{t('Position Opened')}</p>
                        <p>{t('Amount')}</p>
                        {/* <p>Block Number</p> */}

                        {/* <p>Outcome</p> */}
                        <p>{t('Realized PnL')}</p>
                      </div>

                      <div className="bottom-fields" style={{ minHeight: "400px" }}>
                        {smartAccount ? (
                          mergedBetHistory && mergedBetHistory.length > 0 ? (
                            mergedBetHistory.map((bet, i) => {
                              const amountInEther = parseFloat(
                                Web3?.utils?.fromWei(String(bet?.amount), "mwei")
                              );
                              const finalAmount = amountInEther
                              let payout
                              if (bet.type === "win") {
                                let payOut = Web3?.utils?.fromWei(String(bet?.settlement), "mwei")
                                payout = (+payOut) - (+finalAmount)
                              } else {
                                payout = amountInEther

                              }
                              return (
                                <div className="single-field" key={i}>
                                  {/* Transaction Hash + Link */}
                                  <a
                                    href={`${arbiscan_url}/${bet.transactionHash}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {shortenAddress(bet.transactionHash)}{" "}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12"
                                      height="12"
                                      viewBox="0 0 12 12"
                                      fill="none"
                                    >
                                      <path
                                        d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                        stroke="#797979"
                                        strokeWidth="1.04"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M10.5 1.5L6 6"
                                        stroke="#797979"
                                        strokeWidth="1.04"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M7.5 1.5H10.5V4.5"
                                        stroke="#797979"
                                        strokeWidth="1.04"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </a>

                                  {/* Timestamp */}
                                  <h6 style={{ flexDirection: "column", alignItems: "flex-start" }}>
                                    {
                                      epochToDateFormate(bet.blockTimestamp, true)
                                    }
                                    <span className="datetext">{
                                      epochToDateFormate(bet.blockTimestamp)
                                    }</span>
                                  </h6>

                                  {/* Bet Amount */}

                                  <h6>
                                    ${formatSmartDecimal(finalAmount)}</h6>

                                  {/* Block Number */}
                                  {/* <h6>{bet.blockNumber}</h6> */}



                                  {/* Win/Loss */}
                                  {/* <h6
                                  className={
                                    bet.type === "win" ? "green" : "red"
                                  }
                                >
                                  {bet.type === "win" ? "Profit" : "Loss"}
                                </h6> */}

                                  {/* Payout */}

                                  <h6
                                    className={
                                      bet.type === "win" ? "green" : "red"
                                    } >
                                    {bet.type === "win" ? "+" : "-"}
                                    ${formatSmartDecimal(payout)}</h6>
                                </div>
                              );
                            })
                          ) : (
                            // No bets yet
                            <div className="connectwalletmain w-100">
                              <div className="mainimg">
                                <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                                  <path d="M3.5 3.5L38.5 38.5" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M14.6124 4.70799C17.781 3.47043 21.2416 3.18318 24.5709 3.88137C27.9001 4.57956 30.9538 6.23292 33.3582 8.6392C35.7626 11.0455 37.4136 14.1004 38.1092 17.4302C38.8049 20.76 38.5149 24.2204 37.2749 27.388" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M33.3901 33.3899C31.7631 35.0169 29.8314 36.3076 27.7056 37.1882C25.5797 38.0687 23.3012 38.522 21.0001 38.522C18.6991 38.522 16.4206 38.0687 14.2947 37.1882C12.1688 36.3076 10.2372 35.0169 8.61013 33.3899C6.98306 31.7628 5.69239 29.8312 4.81182 27.7053C3.93125 25.5794 3.47803 23.3009 3.47803 20.9999C3.47803 18.6988 3.93125 16.4203 4.81182 14.2944C5.69239 12.1686 6.98306 10.2369 8.61013 8.60986" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </div>
                              <h6 className="connecthead">
                                {t('No opened positions yet.')}
                              </h6>
                            </div>
                          )
                        ) : (
                          // Wallet not connected
                          <div className="connectwalletmain w-100">
                            <h6 className="connecthead">
                              {t("You Haven't Connected Your Wallet Yet")}
                            </h6>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="history-section-mbl w-100">
                    <div className="parent-cards">
                      {smartAccount ? (
                        mergedBetHistory && mergedBetHistory.length > 0 ? (
                          mergedBetHistory.map((bet, i) => {
                            const amountInEther = parseFloat(
                              Web3?.utils?.fromWei(String(bet?.amount), "mwei")
                            );
                            const finalAmount =
                              amountInEther
                            let payout
                            if (bet.type === "win") {
                              let payOut = Web3?.utils?.fromWei(String(bet?.settlement), "mwei")
                              payout = (+payOut) - (+finalAmount)
                            } else {
                              payout = amountInEther

                            }

                            return (
                              <div className="single-card" key={i}>
                                {/* Tx Hash */}
                                <div className="text">
                                  <p>{t('Tx Hash')}</p>
                                  <a
                                    href={`${arbiscan_url}/${bet.transactionHash}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {shortenAddress(bet.transactionHash)}{" "}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12"
                                      height="12"
                                      viewBox="0 0 12 12"
                                      fill="none"
                                    >
                                      <path
                                        d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                        stroke="#797979"
                                        strokeWidth="1.04"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M10.5 1.5L6 6"
                                        stroke="#797979"
                                        strokeWidth="1.04"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M7.5 1.5H10.5V4.5"
                                        stroke="#797979"
                                        strokeWidth="1.04"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </a>
                                </div>

                                {/* Trade Amount */}
                                <div className="text">
                                  <p>{t('Amount')}</p>
                                  <h6>${finalAmount ? formatSmartDecimal(finalAmount) : "0.00"}</h6>
                                </div>

                                {/* Time */}
                                <div className="text">
                                  <p>{t('Position Opened')}</p>
                                  <h6 style={{ flexDirection: "column", alignItems: "flex-start" }}>
                                    {
                                      epochToDateFormate(bet.blockTimestamp, true)
                                    }
                                    <span className="datetext">{
                                      epochToDateFormate(bet.blockTimestamp)
                                    }</span>

                                  </h6>
                                </div>

                                {/* Cashout */}
                                <div className="text">
                                  <p>{t('Realized PnL')}</p>
                                  <h6
                                    className={
                                      bet.type === "win" ? "green" : "red"
                                    } >
                                    {bet.type === "win" ? "+" : "-"}${formatSmartDecimal(payout)}</h6>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          // No bets yet
                          <div className="connectwalletmain w-100">
                            <h6 className="connecthead">
                              {t("You Haven't Placed Any Position Yet")}
                            </h6>
                            <p className="connectpara">
                              {t('Your positions will show up here after you place one.')}
                            </p>
                          </div>
                        )
                      ) : (
                        // Wallet not connected
                        <div className="connectwalletmain w-100">
                          <h6 className="connecthead">
                            {t("You Haven't Connect Your Wallet Yet")}
                          </h6>
                          <p className="connectpara">
                            {t('Click here to connect your wallet.')}
                          </p>
                        </div>
                        // <div className="connectwalletmain w-100">
                        //     <div className="mainimg">
                        //       <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                        //         <path d="M3.5 3.5L38.5 38.5" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                        //         <path d="M14.6124 4.70799C17.781 3.47043 21.2416 3.18318 24.5709 3.88137C27.9001 4.57956 30.9538 6.23292 33.3582 8.6392C35.7626 11.0455 37.4136 14.1004 38.1092 17.4302C38.8049 20.76 38.5149 24.2204 37.2749 27.388" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                        //         <path d="M33.3901 33.3899C31.7631 35.0169 29.8314 36.3076 27.7056 37.1882C25.5797 38.0687 23.3012 38.522 21.0001 38.522C18.6991 38.522 16.4206 38.0687 14.2947 37.1882C12.1688 36.3076 10.2372 35.0169 8.61013 33.3899C6.98306 31.7628 5.69239 29.8312 4.81182 27.7053C3.93125 25.5794 3.47803 23.3009 3.47803 20.9999C3.47803 18.6988 3.93125 16.4203 4.81182 14.2944C5.69239 12.1686 6.98306 10.2369 8.61013 8.60986" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                        //       </svg>
                        //     </div>
                        //     <h6 className="connecthead">
                        //       No Activity yet.
                        //     </h6>
                        //   </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            }
            {
              (window.innerWidth < 991 ? crashmbltab === "activity" : true) &&
              <Players
                gameState={gameState}
                winningsHistory={winningsHistory}
                setWinningsHistory={setWinningsHistory}
              />
            }
          </div>


        </div>
      </section>
      <Footer />

      <Modal
        className="congratsmodal evaluation-modal"
        show={showbet3}
        onHide={handleClosebet3}
        centered
      >
        <Modal.Body>
          <div className="evaluation-parent mb-3">
            {
              theme != LIGHT_THEME ? <img src="\assets\riskmarket\modalbg.png" alt="img" className="img-fluid position-bg" /> : <img src="\assets\riskmarket\modalbglight.png" alt="img" className="img-fluid position-bg" />
            }
            <div className="upper-field">
              <img src="\assets\riskmarket\lightrain.svg" alt="img" className="img-fluid" />
              <h6><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 8.66675V13.3334C8 13.687 8.14048 14.0262 8.39052 14.2762C8.64057 14.5263 8.97971 14.6667 9.33333 14.6667C9.68696 14.6667 10.0261 14.5263 10.2761 14.2762C10.5262 14.0262 10.6667 13.687 10.6667 13.3334" stroke="#797979" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8 1.33325V2.66659" stroke="#797979" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.9947 8.66665C14.0983 8.6675 14.2007 8.6442 14.2937 8.59858C14.3867 8.55297 14.4679 8.48629 14.5306 8.40385C14.5934 8.32142 14.6361 8.22548 14.6553 8.12367C14.6745 8.02185 14.6697 7.91696 14.6413 7.81731C14.2632 6.34323 13.4054 5.03684 12.2031 4.10398C11.0007 3.17111 9.52215 2.66479 8.00035 2.66479C6.47854 2.66479 4.99998 3.17111 3.79763 4.10398C2.59527 5.03684 1.73746 6.34323 1.35935 7.81731C1.33109 7.91647 1.32623 8.02083 1.34513 8.12219C1.36403 8.22354 1.40618 8.31914 1.46827 8.40145C1.53036 8.48376 1.6107 8.55055 1.70296 8.59657C1.79523 8.64258 1.89691 8.66657 2.00001 8.66665H13.9947Z" stroke="#797979" stroke-linecap="round" stroke-linejoin="round" />
              </svg>{t('Risk Market')}</h6>
            </div>
            <div className="mid-part">
              <div className="left-part">
                <h5><img src={
                  userProfile?.profilePic ||
                  "https://dh3bzuu7a45gi.cloudfront.net/gems/creator/81eacfe1d71041249a196234f5c5686e.jpeg"
                } alt="img" className="img-fluid" />
                  {shortenName(userProfile?.name) || getFormatedWeb3Address(smartAccount, true)}
                </h5>
                <h2 style={{ color: isBetLoss ? "var(--logout-text)" : "var(--green-text)" }}>{!isBetLoss ? convertXvalueToPercentageOnlyForPayoutX(winxxx) : formatNumberWithCommas(userCashoutValue)}%</h2>
              </div>
              {/* <div className="right-img">
                <img src="\assets\riskmarket\multirainimg.png" alt="img" className="img-fluid" />
              </div> */}
            </div>
            <div className="bottom-card">
              <div className="left-text">
                <p>{t('Amount')}</p>
                <h6>${betAmount ? (convertBetAmountWithOutFee(+betAmount, true)) : formatSmartDecimal(winBetAmount)}</h6>
              </div>
              <div className="right-text">
                <p>{t('Realized PnL')}</p>
                <h6 style={{ color: isBetLoss ? "var(--logout-text)" : "var(--green-text)" }}>+${isBetLoss ? convertBetAmountWithOutFee(+betAmount, true) : formatSmartDecimal(winPrice)}</h6>
              </div>
            </div>
          </div>
          <div className="network-fee">
            <p>{t('Network Fee')}</p>
            <h6>${formatSmartDecimal(cashoutEstimatedFee)}</h6>
          </div>
          <ShareCrash
            smartAccount={smartAccount}
            percentage={!isBetLoss ? convertXvalueToPercentage(winxxx) : formatNumberWithCommas(userCashoutValue)}
            exposureAmount={convertBetAmountWithOutFee(+betAmount, true)}
            realizedPnl={isBetLoss ? (convertBetAmountWithOutFee(+betAmount, true)) : formatSmartDecimal(winPrice)} />
          {
            !isBetLoss ? <button onClick={handleClosebet3} className="close">
              {t('Claim')}
            </button> :
              <div className="twice-btns">
                <button onClick={handleClosebet3} className="close setbtnsizembl">
                  {t('Close')}
                </button>
                <button disabled={betPlaced || countDownCheck || gameState == "running"} className="btn-position setbtnsizembl" onClick={() => {
                  handleBetNow()
                  handleClosebet3()
                }}>
                  {t('Open Position Again')}
                </button>
              </div>
          }

        </Modal.Body>
      </Modal>

      <Offcanvas
        show={show1}
        onHide={handleClose1}
        className="historysidebar"
        placement="bottom"
      >
        <Offcanvas.Header>
          <Offcanvas.Title>{t('Market History')}</Offcanvas.Title>
          <button className="closebtn" onClick={() => setShow1(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className="lightsvg"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className="darksvg"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="dropmain">
            <div className="midbody">
              <h6><span style={{ background: "#F9AD51" }}></span>1% - 100%</h6>
              <h6><span style={{ background: "#00BB96" }}></span>101% - 900%</h6>
              <h6><span style={{ background: "#8559E3" }}></span>901% - 9900%</h6>
            </div>
            <div className="dropbody">
              <div className="maintable">
                <table>
                  <thead>
                    {/* <th>ID</th> */}
                    <th>{t('Result')}</th>
                    <th>{t('Hash')}</th>
                  </thead>
                  <tbody>
                    {recentGamesData?.map((item, index) => {
                      const rng = parseFloat(10000 / item?.derivedNumber); // <-- use rng directly
                      const txHash = item?.transactionHash;
                      const shortTx = `${txHash.slice(0, 6)}...${txHash?.slice(
                        -4
                      )}`;
                      let circleClass = "green";
                      let textClass = "greentext";

                      if (rng > 2 && rng <= 10) {
                        circleClass = "yellow";
                        textClass = "yellowtext";
                      } else if (rng > 10) {
                        circleClass = "purple";
                        textClass = "purpletext";
                      }

                      return (
                        <tr key={index}>
                          {/* <td>
                            <div className="mainnumber">
                              <span className={`circle ${circleClass}`}></span>
                              <p className={`numberpara ${textClass}`}>
                                {item.indexId}
                              </p>
                            </div>
                          </td> */}
                          <td>
                            <div className="mainnumber">
                              <span className={`circle ${circleClass}`}></span>
                              <p className={`numberpara ${textClass}`}>
                                {isFinite(rng) ? `${formatNumberWithCommas(convertXvalueToPercentage(rng))}%` : "0%"}
                              </p>
                            </div>
                          </td>
                          <td><a className="mainlink" href={`${arbiscan_url}/${txHash}`} target="_blank">{shortTx}<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <g clip-path="url(#clip0_9211_4351)">
                              <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#75768F" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M10.5 1.5L6 6" stroke="#75768F" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.5 1.5H10.5V4.5" stroke="#75768F" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_9211_4351">
                                <rect width="12" height="12" fill="white" />
                              </clipPath>
                            </defs>
                          </svg></a></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Modal
        className="congratsmodal terminationmodal"
        show={terminationmodal}
        onHide={handleCloseTerminationModal}
        centered
      >
        <Modal.Header closeButton>
          <div className="twice-header">
            <div className="main-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                <path d="M24.8461 7.47266L14.1982 18.1205L9.46578 13.3881L2.36719 20.4867" stroke="black" stroke-width="1.69014" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M24.8462 13.3881V7.47266H18.9307" stroke="black" stroke-width="1.69014" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div className="text">
              <h6>{t('Risk Market')}</h6>
              <p>{t('A decision-based financial instrument')}</p>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="how-it-works">
            <h6>{t('How it works')}</h6>
            <p style={{ border: "none" }}>{t('When you initiate a position, a scenario begins. The scenario factor increases gradually over time, representing potential return. However, the scenario can terminate at any moment, returning the factor to zero.')}</p>
            <div className="label-img">
              {
                theme != LIGHT_THEME ? <img src="\assets\riskmarket\howitworksdark.png" alt="img" className="img-fluid w-100" /> :
                  <img src="\assets\riskmarket\howitworks.png" alt="img" className="img-fluid w-100" />
              }
              <div className="inline-text">
                <p>1.0%</p>
                <p>{t('Growth')}</p>
                <p>{t('Unknown')}</p>
              </div>
            </div>
            <h6>{t('Your decision')}</h6>
            <p>{t('You choose when to realize your position, locking in the current scenario factor. The longer you wait, the higher the potential return, but also the greater the risk of termination.')}</p>
            <div className="parent-twice">
              <div className="single">
                <div className="main-img">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 6V12L16 14" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div className="text">
                  <h6>{t('Timing')}</h6>
                  <p>{t('Risk increases with duration')}</p>
                </div>
              </div>
              <div className="single">
                <div className="main-img">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div className="text">
                  <h6>{t('Realization')}</h6>
                  <p>{t('Lock in factor at any time')}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="para-box">
            <p>{t('Termination timing is uncertain. Each scenario evolves independently.')} <br />
              {t('Your judgment determines when to act.')}</p>
          </div>
          {smartAccount ?
            <>
              {!userProfile?.riskMarketDisclaimer ?
                <>
                  <button onClick={riskMarketDisclaimerApi} className="btn-market">{t('Continue to Market')}</button>
                  <div class="custom-checkbox">
                    <input type="checkbox" id="html" checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)} />
                    <label for="html">{t('Don’t show this again')}</label>
                  </div>
                </>
                :
                <button onClick={handleCloseTerminationModal} className="btn-market">{t('Continue to Market')}</button>
              }
            </>
            :
            <button onClick={handleCloseTerminationModal} disabled className="btn-market">    {t('Please connect your wallet')}</button>
          }

        </Modal.Body>
      </Modal>


    </>
  );
};

export default Crash;